export const API_KEY = 'BW3c3zUtvA5ynJwzZ4Wc44pUUvtNA3rrMet5efPu8dcdMA9PMHm';

export const HELP_PORTAL_COMMS_API_BASE_URL =
  'https://europe-west1-balwin-60c4a.cloudfunctions.net/helpPortalCommsAPI';

export const API_ENDPOINTS = {
  ISSUE_TYPES: '/issueTypes',
  ISSUE: '/issue',
  CREATE_AND_EMAIL_ISSUE: '/createAndEmailIssue',
  UPDATE_AND_EMAIL_ISSUE: '/updateAndEmailIssue',
};

export const buildHelpPortalApiUrl = (endpoint) =>
  `${HELP_PORTAL_COMMS_API_BASE_URL}${endpoint}`;
